module.exports = `:root {
  --primitiveColorNeutral0: #000000;
  --primitiveColorNeutral360: #505662;
  --primitiveColorNeutral860: #d7d7db;
  --primitiveColorNeutral970: #f5f5f5;
  --primitiveColorNeutral1000: #ffffff;
  --primitiveColorBrand140: #00254a;
  --primitiveColorBrand490: #008193;
  --primitiveColorBrand750: #69c9bf;
  --primitiveTypographyTypescale1: 3.5rem;
  --primitiveTypographyTypescale2: 3rem;
  --primitiveTypographyTypescale3: 2.25rem;
  --primitiveTypographyTypescale4: 1.75rem;
  --primitiveTypographyTypescale5: 1.5rem;
  --primitiveTypographyTypescale6: 1.25rem;
  --primitiveTypographyTypescale7: 1.125rem;
  --primitiveTypographyTypescale8: 1rem;
  --primitiveTypographyTypescale9: 0.875rem;
  --primitiveTypographyTypescale10: 0.75rem;
}
`;